// Rice's undergraduate majors (#2652, batch 2). Read on 2026-10-01 from the
// General Announcements 2026-2027, Departments and Programs (ga.rice.edu/
// programs-study/departments-programs/), its Academic School View: every
// program whose Undergraduate column lists a bachelor's degree (BA, BS,
// BArch, BMus, BSBE, BSChE and the other engineering BS degrees); minors,
// certificates and graduate-only programs left out. The GA says it is the
// official Rice curriculum. The KB's majors list was the starting point;
// the GA wins.
const majors = {
    "slug": "rice-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Rice's official General Announcements 2026-2027, grouped by the school that offers it, with the degree it leads to. Minors, certificates and graduate-only programs are left out.",
    "groups": [
        {
            "name": "School of Architecture",
            "source": {
                "label": "Rice General Announcements 2026-2027, Departments and Programs",
                "url": "https://ga.rice.edu/programs-study/departments-programs/"
            },
            "note": "Architecture applicants submit a portfolio of creative work.",
            "noteSource": "firstYear",
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Architecture and Building Science",
                    "degree": "BArch"
                }
            ]
        },
        {
            "name": "George R. Brown School of Engineering and Computing",
            "source": {
                "label": "Rice General Announcements 2026-2027, Departments and Programs",
                "url": "https://ga.rice.edu/programs-study/departments-programs/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BA, BSChE"
                },
                {
                    "name": "Civil and Environmental Engineering",
                    "degree": "BA"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computational and Applied Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA, BSCS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BA, BSECE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Materials Science and NanoEngineering",
                    "degree": "BA, BSMSNE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BA, BSME"
                },
                {
                    "name": "Operations Research",
                    "degree": "BA, BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "School of Humanities and Arts",
            "source": {
                "label": "Rice General Announcements 2026-2027, Departments and Programs",
                "url": "https://ga.rice.edu/programs-study/departments-programs/"
            },
            "majors": [
                {
                    "name": "Ancient Mediterranean Civilizations",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "European Studies",
                    "degree": "BA"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Latinx Studies",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Medieval and Early Modern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Study of Women, Gender, and Sexuality",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "Rice General Announcements 2026-2027, Departments and Programs",
                "url": "https://ga.rice.edu/programs-study/departments-programs/"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Shepherd School of Music",
            "source": {
                "label": "Rice General Announcements 2026-2027, Departments and Programs",
                "url": "https://ga.rice.edu/programs-study/departments-programs/"
            },
            "note": "Music applicants send extra materials by December 1 and cannot apply Early Decision or through QuestBridge.",
            "noteSource": "firstYear",
            "majors": [
                {
                    "name": "Bassoon Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Cello Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Clarinet Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Composition",
                    "degree": "BMus"
                },
                {
                    "name": "Double Bass Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Flute Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Harp Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Horn Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music History",
                    "degree": "BMus"
                },
                {
                    "name": "Music Theory",
                    "degree": "BMus"
                },
                {
                    "name": "Oboe Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Orchestral Conducting",
                    "degree": "BMus"
                },
                {
                    "name": "Organ Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Percussion Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Piano Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Trombone Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Trumpet Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Tuba Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Viola Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Violin Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Vocal Performance",
                    "degree": "BMus"
                }
            ]
        },
        {
            "name": "Wiess School of Natural Sciences",
            "source": {
                "label": "Rice General Announcements 2026-2027, Departments and Programs",
                "url": "https://ga.rice.edu/programs-study/departments-programs/"
            },
            "majors": [
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biosciences",
                    "degree": "BA, BS"
                },
                {
                    "name": "Chemical Physics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA, BS"
                },
                {
                    "name": "Earth, Environmental and Planetary Sciences",
                    "degree": "BA, BS"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA, BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Public Health Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Sports Medicine and Exercise Physiology",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "School of Social Sciences",
            "source": {
                "label": "Rice General Announcements 2026-2027, Departments and Programs",
                "url": "https://ga.rice.edu/programs-study/departments-programs/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Global Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Managerial Economics and Organizational Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Economic Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Social Policy Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sport Analytics",
                    "degree": "BA"
                },
                {
                    "name": "Sport Management",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
